<div class="xi-modal__container" *transloco="let t; prefix: 'widgets.create-insight-feed-dialog'">
  <h2 class="xi-modal__title kxi-text-center">
    {{ options()?.action === 'create' ? t('create-new-feed') : t('edit-feed') }}
  </h2>

  <form [formGroup]="createFeedForm">
    @if (isLoading()) {
      <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
        <xi-animation [height]="75" [width]="75" [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    }

    <div class="xi-modal__content create-feed__content">
      <div class="create-feed__top-section-container">
        <xi-input-field
          name="name"
          formControlName="name"
          [label]="t('feed-name')"
          [status]="nameStatus"
        ></xi-input-field>
      </div>

      <div class="create-feed__horizontal-line"></div>

      <div class="create-feed__field-wrapper">
        <label for="tags-dropdown" class="create-feed__label">{{ t('tags') }}</label>
        <xi-dropdown
          inputId="tags-dropdown"
          formControlName="tags"
          [placeholder]="t('add-tags')"
          [data]="dropdownTags"
          select="multi"
          [inMenuSearch]="true"
        >
        </xi-dropdown>
      </div>

      <div class="create-feed__field-wrapper" formGroupName="filters">
        <div>{{ t('filters') }}</div>
        @if (!isLoadingFilters()) {
          @for (f of filterTypes(); track f.type) {
            @if (!f.isOpen) {
              <div class="create-feed__filter-name">
                <xi-icon-button icon="add_circle" (click)="toggleFilterDisplay(f)">
                </xi-icon-button>
                <div>
                  {{ f.sectionLabel }}
                </div>
              </div>
            } @else {
              <div class="create-feed__filter-input">
                <xi-dropdown
                  [data]="f.data"
                  [label]="f.inputLabel"
                  select="multi"
                  [formControlName]="f.type"
                  [placeholder]="f.sectionLabel"
                  [inMenuSearch]="true"
                ></xi-dropdown>
                <xi-icon-button icon="cancel" (click)="clearFilter(f)"></xi-icon-button>
              </div>
            }
          }
        }
      </div>

      <div class="create-feed__field-wrapper">
        <label for="visbility-dropdown" class="create-feed__label">{{
          t('feed-visibility')
        }}</label>
        <div class="create-feed__visibility_container">
          <xi-dropdown
            inputId="visbility-dropdown"
            formControlName="visibility"
            [data]="feedVisibility"
            [placeholder]="t('select-visibility')"
            (onValueChange)="onFeedVisibilityChange($event)"
          >
          </xi-dropdown>

          @if (areLabelsVisible()) {
            <app-item-labels
              [item]="labelItem"
              [isReadOnly]="false"
              (labelApplied)="onLabelApplied($event)"
              (labelRemoved)="onLabelRemoved($event)"
            ></app-item-labels>
          }
        </div>
      </div>
    </div>
    <div
      class="xi-modal__actions"
      [ngClass]="
        options()?.action === 'create' ? 'create-feed__create-actions' : 'create-feed__edit-actions'
      "
    >
      @if (options()?.action === 'edit') {
        <xi-default-button [text]="t('delete')" fill="text" color="error" (onClick)="onDelete()">
        </xi-default-button>
      }
      <xi-default-button
        [text]="t('cancel')"
        fill="text"
        (onClick)="onCancel()"
      ></xi-default-button>

      <xi-default-button
        fill="outline"
        [text]="options()?.action === 'create' ? t('create-new-feed') : t('save-as-new-feed')"
        [disabled]="createFeedForm.status !== 'VALID' || !hasFeedNameChanged()"
        [tooltipDisplayOnDisabled]="true"
        [tooltip]="!hasFeedNameChanged() ? { text: t('feed-name-edit-tooltip') } : undefined"
        (onClick)="onCreateOrUpdate('create')"
      ></xi-default-button>

      @if (options()?.action === 'edit') {
        <xi-default-button
          [text]="t('save-changes')"
          [disabled]="createFeedForm.status !== 'VALID'"
          (onClick)="onCreateOrUpdate('edit')"
        ></xi-default-button>
      }
    </div>
  </form>
</div>
